<template>
  <v-select
    v-model="selected"
    label="Order Status"
    :items="items"
    :loading="isLoading"
    outlined
    dense
    clearable
    item-text="name"
    item-value="id"
  />
</template>

<script>
export default {
  name: "AppOrderStatusAutocomplete",
  props: {
    serviceId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    isLoading: false,
    items: [],
    status: [],
    selected: null,
    services: [],
  }),

  watch: {
    selected: function () {
      this.$emit("input", this.selected);
    },
    serviceId: function () {
      this.items = [];
      this.items = [...this.status];
      if (this.serviceId) {
        let found = _.find(this.services, {
          id: this.serviceId,
        });

        this.items = this.items.filter((item) => {
          return item.group === found.serviceName;
        });
      }
    },
  },
  mounted() {
    this.loadOrderStatus();
    this.loadServices();
  },
  methods: {
    loadOrderStatus: async function () {
      const self = this;
      self.isLoading = true;
      const { data } = await axios.get("/admin/setting/order-statuses");
      Object.keys(data.data).forEach((key) => {
        Object.keys(data.data[key]).forEach((k) => {
          self.status.push({ id: k, name: data.data[key][k], group: key });
        });
      });
      self.items = [...self.status];
      self.isLoading = false;
    },
    loadServices: async function () {
      const self = this;
      self.isLoading = true;
      const { data } = await axios.get("/app/services");
      self.services = data.data;
      self.isLoading = false;
    },
  },
};
</script>
<style lang="scss" scope>
.v-list--dense .v-subheader {
  font-size: 1.2rem !important;
  font-weight: 800 !important;
}
</style>
